// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedSurveys_root__j7d_H"};